<template>
  <div class="home">
    <van-nav-bar title="个人评估" left-arrow @click-left="onClickLeft" />
    <main class="main">
      <div class="studydatabox">
        <p class="title">Hi, 这是你的学习数据</p>
        <div class="studytime">
          <span class="studytitle">累计学习时长</span>
          <span class="studynum"
            ><b class="num">{{ AllLearnedData.totalLearnTime || 0 }}</b
            >小时</span
          >
        </div>
        <div class="line"></div>
        <ul>
          <li>
            <p>
              <b>{{ AllLearnedData.todayLearnTime || 0 }}</b>
            </p>
            <p>今天学习</p>
          </li>
          <li>
            <p>
              <b>{{ AllLearnedData.thisWeekLearnTime || 0 }}</b>
            </p>
            <p>本周学习</p>
          </li>
          <li>
            <p>
              <b>{{ AllLearnedData.thisMonthLearnTime  || 0 }}</b>
            </p>
            <p>本月学习</p>
          </li>
        </ul>
      </div>
      <!-- <div class="xunlianyin">
        <div class="xunlianyintitle">
          <span class="title">您参加的训练营</span>
        </div>
        <ul>
          <li>
            <p>
              <b>{{ TrainCampData.allTrainCount || 0 }}</b>
            </p>
            <p>全部</p>
          </li>
          <li>
            <p>
              <b>{{ TrainCampData.notStartTrainCount || 0 }}</b>
            </p>
            <p>未开始</p>
          </li>
          <li>
            <p>
              <b>{{ TrainCampData.runningTrainCount || 0 }}</b>
            </p>
            <p>进行中</p>
          </li>
         
          <li>
            <p>
              <b>{{ TrainCampData.endTrainCount || 0 }}</b>
            </p>
            <p>已结束</p>
          </li>
        </ul>
      </div> -->
    </main>
    <footer class="footer"></footer>
  </div>
</template>
<script>
export default {
  name: "assess",
  data() {
    return {
      AllLearnedData: "",
      TrainCampData: "",
    };
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    getAllLearnedData() {
      this.$api.myassessment.getAllLearnedData().then((res) => {
        this.AllLearnedData = res.data;
        console.debug(this.AllLearnedData);
      });
    },
    getAllTrainCampData() {
      this.$api.myassessment.getAllTrainCampData().then((res) => {
        this.TrainCampData = res.data;
        console.debug(this.TrainCampData);
      });
    },
    //  async getAllLearnedData() {
    //    const params = {}
    //    const data = {}
    //   const Learned = await this.$api.myassessment.getAllLearnedData({ params, data }).then(res => {
    //     return res
    //   });
    //   console.debug(Learned, 'Learned')
    // },
  },
  mounted() {
    this.getAllLearnedData();
    this.getAllTrainCampData();
  },
};
</script>
<style lang="stylus" scoped>
.home {
  height: 100%;
  display: flex;
  flex-direction: column;

  .header {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // border-bottom: 1px solid #ccc;
    // background: #ccc;
    padding: 0 30px;

    img {
      width: 50%;
    }

    .headertitle {
      font-size: 36px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }

    span:nth-child(3) {
      width: 50px;
    }
  }

  .main {
    flex: 1;
    overflow: hidden;

    .studydatabox {
      height: 400px;
      background: url('https://wd-appdownload.oss-cn-beijing.aliyuncs.com/hrss-h5/account/studydatabg.png') no-repeat;
      background-repeat: no-repeat;
      background-size: 93% 100%;
      -webkit-background-size: 93% 100%;
      -o-background-size: 93% 100%;
      background-position: center 0;
      margin-top: 50px;
      position: relative;
      box-sizing: border-box;

      .title {
        height: 36px;
        font-size: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #6AC9FF;
        line-height: 36px;
        position: absolute;
        top: 50px;
        left: 60px;
      }

      .studytime {
        height: 50px;
        font-size: 40px;
        position: absolute;
        // top: 148px;
        top: 158px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        padding: 0 90px;
        box-sizing: border-box;

        .studytitle {
          height: 40px;
          font-size: 40px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 40px;
          white-space: nowrap;
        }

        .studynum {
          height: 26px;
          font-size: 24px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 26px;
          white-space: nowrap;

          .num {
            height: 50px;
            font-size: 70px;
            font-family: HelveticaNeue-Medium, HelveticaNeue;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 50px;
          }
        }
      }

      .line {
        height: 1px;
        background: #FFFFFF;
        opacity: 0.2;
        position: absolute;
        // top: 285px;
        top: 245px;
        left: 0;
      }

      ul {
        width: 100%;
        display: flex;
        text-align: center;
        position: absolute;
        left: 32px;
        top: 279px;

        li {
          // margin-left: 155px;
          width: 33.33%;
          margin: 0 65px;

          p:nth-child(1)>b {
            height: 46px;
            font-size: 46px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            line-height: 46px;
          }

          p:nth-child(2) {
            // margin-top: 22px;
            margin-top: 12px;
            height: 26px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #C1D4FE;
            line-height: 26px;
          }
        }

        li:nth-child(1) {
          margin-left: 0;
        }
      }
    }

    .xunlianyin {
      height: 245px;
      background: #F8F9FF;
      border-radius: 24px;
      margin: 30px;

      .xunlianyintitle {
        height: 90px;
        line-height: 90px;
        background: #EDF0FF;
        border-radius: 24px 24px 0px 0px;

        // opacity: 0.0567;
        .title {
          padding-left: 20px;
          font-size: 34px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3760FF;
        }
      }

      ul {
        display: flex;
        text-align: center;
        justify-content: space-between;
        padding: 0 20px;
        align-items: center;
        margin-top: 33px;

        // position: absolute;
        // left: 96px;
        // top: 279px;
        li {
          p:nth-child(1)>b {
            height: 46px;
            font-size: 46px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #3760FF;
            line-height: 46px;
          }

          p:nth-child(2) {
            margin-top: 12px;
            height: 26px;
            font-size: 24px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #3760FF;
            line-height: 26px;
            color: #8099FF;
          }
        }
      }
    }
  }
}
</style>